import { Outlet } from 'react-router';
import { useState } from 'react';
import SubVisual from '@/components/SubVisual';
import { InquiryTab } from '@/pages/inquiry/constants';

const InquiryPage = () => {
	const [activeTab, setActiveTab] = useState(0);

	const handleTabChange = (index: number) => {
		setActiveTab(index);
	};

	return (
		<main id="sub" className="sub inquiry">
			<SubVisual
				cate={activeTab === 0 ? '서비스 문의' : '제휴 문의'}
				title={InquiryTab.title}
				subTab={InquiryTab.subTab}
				onChangeTab={handleTabChange}
			/>
			<Outlet />
		</main>
	);
};

export default InquiryPage;
